// Display formatting helpers.

/**
 * Human label for a student on teacher-facing screens.
 * NEVER renders a raw UUID (Block D2 rule): prefer the real display name,
 * then the email local-part, then a prettified demo slug, else a generic label.
 * Accepts any object carrying student_name / student_email / student_id.
 */
export const studentLabel = (obj = {}) => {
  if (obj.student_name) return obj.student_name;
  if (obj.student_email) return obj.student_email.split('@')[0];
  const id = obj.student_id || '';
  if (id.startsWith('demo-student-')) {
    return id
      .replace('demo-student-', '')
      .split('-')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');
  }
  return 'Student';
};
